import React from 'react';
import { Props_SnippetQuote } from './Quote.props';
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler';
import SharedHeading from '../Shared/Heading/Heading';

const SnippetQuote = (props: Props_SnippetQuote) => {
    const { quote, citation, heading } = props;
    // Ensure correct types for heading props
    const headingLevel = (heading.level?.value as 'h1'|'h2'|'h3'|'h4'|'h5'|'h6') || 'h2';
    const headingAlignment = (heading.alignment?.value as 'start'|'center'|'end') || undefined;
    // Convert heading.visibility?.value to boolean
    const headingVisibility = typeof heading.visibility?.value === 'boolean'
        ? heading.visibility.value
        : heading.visibility?.value === 'true';

    return (
        <section className="snippet-quote">
            <div className="snippet-quote__container"> 
                <SharedHeading
                level={headingLevel}
                alignment={headingAlignment}
                visibility={headingVisibility}
                className="snippet-quote__heading"
            >
                {heading.text?.value || (heading as any).content?.value}
            </SharedHeading>
           
                {quote?.content?.value && (
                    <blockquote className="snippet-quote__quote">{CompileMarkdown(quote.content.value)}</blockquote>
                )}
                {citation?.content?.value && (
                    <div className="snippet-quote__citation">{CompileMarkdown(citation.content.value)}</div>
                )}
            </div>
        </section>
    );
};

export default SnippetQuote;
